/* 🤖 this file was generated by svg-to-ts*/
export const icoAnalyticsDuo: {
  name: 'analytics-duo';
  data: string;
} = {
  name: 'analytics-duo',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect opacity=".12" x="3" y="3" width="18" height="18" rx="2" fill="#858585"/><path d="M13 17.17V6.89c0-.49-.45-.89-1-.89s-1 .4-1 .89v10.28c0 .49.45.89 1 .89s1-.4 1-.89zM9 17.11V9.89C9 9.4 8.55 9 8 9s-1 .4-1 .89v7.22c0 .49.45.89 1 .89s1-.4 1-.89zM17 17.11V13.9c0-.49-.45-.89-1-.89s-1 .4-1 .89v3.21c0 .49.45.89 1 .89s1-.4 1-.89z" fill="#858585"/><path d="M18 22H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h12c2.21 0 4 1.79 4 4v12c0 2.21-1.79 4-4 4zM6 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H6z" fill="#858585"/></svg>`
};
